export default __webpack_public_path__ + "static/media/web-app-logo-128.38dc2721.png";